import { Constant } from '@/_services/constant'

export default class CategoryModel {
  /* tslint:disable:variable-name */
  public _id: string = ''
  public name: string = ''
  public color: string = Constant.DEFAULT_CATEGORY_COLOR // Orange
  public user_type: string = Constant.DEFAULT_USER_TYPE
  public category_1: string = ''
  public category_2: string = ''
  public category_3: string = ''
  public created_at: Date = new Date()
  public updated_at: Date = new Date()
}
